import { render, staticRenderFns } from "./pageShengxuejianyi.vue?vue&type=template&id=2a472d7c&scoped=true"
import script from "./pageShengxuejianyi.vue?vue&type=script&lang=js"
export * from "./pageShengxuejianyi.vue?vue&type=script&lang=js"
import style0 from "./pageShengxuejianyi.vue?vue&type=style&index=0&id=2a472d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a472d7c",
  null
  
)

export default component.exports